import React from 'react';
import { Paper, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import { getCurrencySymbol } from '../common/common';

// const topToolbarStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };

const sdoStatuses = [
  // { id: "6", name: 'Scheduled'},
  // { id: "7", name: 'Released for execution'},
  // { id: "11", name: 'Loaded'},
  { id: "5", name: 'Pending' },
  { id: "8", name: 'Ready for Loading' },
  { id: "15", name: 'Dispatched' },
  // { id: "16", name: 'Finished'},
];

const LineItemsSideComponent = ({ record, digital_order }) => {
  if (digital_order) {
    record = digital_order;
  }
  let showConv = (record && record.digital_order_line_items && record.digital_order_line_items.map(li => (li.product_master || {}).show_conversion)) || [];
  showConv = showConv.includes(true);
  return (
    <Paper className="paperWrap">
      <h4>Digital Order Line Items</h4>
      {
        record && record.digital_order_line_items &&
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Product Name
              </TableCell>
              <TableCell>
                Quantity
              </TableCell>
              <TableCell>
                UOM
              </TableCell>
              {
                showConv &&
                <TableCell>
                  Quantity Conversion
                </TableCell>
              }
              {
                showConv &&
                <TableCell>
                  Quantity Conversion UOM
                </TableCell>
              }
              {/* <TableCell>
                {`Unit Price (${record.digital_order_line_items[0].currency})`}
              </TableCell> */}
              {/* <TableCell>
              {`Total (${record.digital_order_line_items[0].currency})`}
              </TableCell> */}
            </TableRow>
          </TableHead>
          {
            <TableBody>
              {
                record.digital_order_line_items.map(lineItem => (
                  <TableRow key={lineItem.id}>
                    <TableCell>
                      {lineItem.product_master && lineItem.product_master.description}
                    </TableCell>
                    <TableCell>
                      {lineItem.quantity}
                    </TableCell>
                    <TableCell>
                      {lineItem.product_master && (lineItem.product_master.input_uom_name || lineItem.product_master.input_uom)}
                    </TableCell>
                    {
                      showConv &&
                      <TableCell>
                        { lineItem.product_master && lineItem.product_master.conversion_factor !== 1 ? (lineItem.quantity * lineItem.product_master.conversion_factor).toFixed(2) : null}
                      </TableCell>
                    }
                    {
                      showConv &&
                      <TableCell>
                        {lineItem.product_master && (lineItem.product_master.conversion_uom_name || lineItem.product_master.conversion_uom)}
                      </TableCell>
                    }
                    {/* <TableCell>
                      {lineItem.unit_price.toFixed(2)}
                    </TableCell>
                    <TableCell>
                      {lineItem.quantity.toFixed(2) * lineItem.unit_price.toFixed(2)}
                    </TableCell> */}
                  </TableRow>
                ))
              }
            </TableBody>
          }
        </Table> 
      }
    </Paper>
  )
};

export { sdoStatuses, LineItemsSideComponent };